let browserHistory = require("react-router").browserHistory;
let connect = require("react-redux").connect;
import React from "react";

let actions = require("../actions/actions");

class ModerationUploadSearch extends React.Component {
    render() {
        let reviewButton = this.renderReviewButton();

        return (
            <section className="container creator-search row">
                <div className="col-lg-10">
                    <div className="input-group input-group-lg">
                        <span className="input-group-addon" id="sizing-addon1">
                            <div className="ui_search" />
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            ref="search-uploads"
                            placeholder="Search for Upload..."
                            aria-describedby="sizing-addon1"
                            onKeyUp={this.searchUploads.bind(this)}
                        />
                    </div>
                </div>
                <div className="col-lg-2">
                    {reviewButton}
                </div>
            </section>
        );
    }

    renderReviewButton() {
        let buttonText = "Start Reviewing";

        if (this.props.hasActiveUpload) {
            buttonText = "Continue Reviewing";
        }

        return (
            <button
                type="button"
                className="btn btn-default blue start-reviewing-general"
                onClick={this.startReviewing.bind(this)}
            >
                {buttonText}
            </button>
        );
    }

    searchUploads(e) {
        let searchTerm = encodeURIComponent(this.refs["search-uploads"].value);
        if (searchTerm === "") {
            this.props.fetchNewUploads("");
        } else if (searchTerm.length > 2) {
            this.props.searchUploads(searchTerm);
        }
    }

    startReviewing() {
        browserHistory.push("/fort/modparty/under-review/");
    }
}

function mapStateToProps(state, ownProps) {
    let hasActiveUpload = { hasActiveUpload: state.uploads.has_active };

    return { hasActiveUpload };
}

module.exports = connect(mapStateToProps, {
    fetchNewUploads: actions.fetchNewUploads,
    searchUploads: actions.searchUploads
})(ModerationUploadSearch);
